<template>
  <div class="d-flex flex-column a-rms-apply-prices" style="gap: 3px">
    <div class="d-flex align-center" style="gap: 5px">
      <v-checkbox
        v-model="apply_all"
        :ref="`price_${date}`"
        value="apply_all"
        color="secondary"
        on-icon="mdi-checkbox-marked"
        off-icon="mdi-checkbox-blank"
        class="ma-0 pa-0"
        hide-details
        dense
      />
      <v-spacer />
      <v-text-field
        v-model="price_local"
        type="number"
        background-color="white"
        class="input-price"
        hide-details
        dense
        solo
        flat
        @input="apply_all = 'apply_all'"
      >
        <template v-slot:append>
          <span class="symbol caption font-weight-bold">
            €
          </span>
        </template>
      </v-text-field>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :loading="loading"
            color="secondary"
            class="main-btn"
            depressed
            x-small
            @click="applyPrice"
          >
            <v-icon size="12">
              mdi-send-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Send") }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import * as Utils from "@/utils.js";

export default {
  name: "a-rms-apply-prices",
  props: {
    price: {
      type: Number,
      required: false
    },
    date: {
      type: String,
      required: true
    },
    hideMoneyIcon: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    price_local: null,
    apply_all: false
  }),
  watch: {
    price(newVal) {
      // Actualizar price_local cuando la prop price cambie
      if (newVal !== null && newVal !== undefined) {
        this.price_local = newVal;
      }
    },
    apply_all(newVal) {
      this.$emit("checkbox-changed", {
        date: this.date,
        price: this.price_local,
        price_current: this.price,
        selected: newVal
      });
    },
    price_local(newVal) {
      if (this.apply_all) {
        this.$emit("checkbox-changed", {
          date: this.date,
          price: newVal,
          price_current: this.price,
          selected: this.apply_all
        });
      }
    }
  },
  methods: {
    applyPrice() {
      this.loading = true;
      this.$store.dispatch("setSnackbar", {
        title: this.$t("applying_price"),
        color: "secondary"
      });
      const data = {
        date: this.date,
        pvp: this.price_local
      };
      this.$store
        .dispatch("setRoomTypeDayRates", data)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("price_applied"),
            color: "accent",
            ...Utils.rateChangeLogSnackbarExtras(this)
          });
          this.$store.dispatch("setReloadSubscribedModules");
        })
        .catch(() => {
          this.loading = false;
          Utils.showError(this, "price_not_applied");
        });
    }
  },
  mounted() {
    // Asignar valor inicial solo si price tiene un valor válido
    if (this.price !== null && this.price !== undefined) {
      this.price_local = this.price;
    }
  }
};
</script>

<style scoped lang="scss">
.a-rms-apply-prices {
  .input-price {
    flex: 0;
    border-radius: 4px 0 0 4px;
    ::v-deep .v-input__control {
      display: inline-flex !important;
      min-height: auto !important;
      .v-input__slot {
        min-height: auto !important;
        padding: 0 3px 0 5px !important;
        input {
          line-height: 1 !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          padding: 2px 0 !important;
          text-align: right;
          width: 25px;
        }
        /* Para navegadores WebKit (Chrome, Safari, Edge) */
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        /* Para Firefox */
        input[type="number"] {
          -moz-appearance: textfield;
        }
        .v-input__append-inner {
          margin: 0 0 0 0 !important;
          padding: 0 !important;
          .symbol {
            font-size: 10px !important;
            margin-left: 1px;
          }
        }
      }
    }
  }
  .v-input--checkbox {
    ::v-deep .v-input--selection-controls__input {
      margin: 0 !important;
      height: auto;
      width: 22px;
      .v-icon {
        font-size: 14px !important;
        &.mdi-checkbox-blank {
          color: #e2e2e2 !important;
        }
      }
      .v-input--selection-controls__ripple {
        width: 17px;
        height: 17px;
        left: 2px;
        top: -1.5px;
        margin: 0;
      }
    }
  }
  .v-btn {
    background-color: #e2e2e2 !important;
    height: 100%;
    min-width: auto;
    padding: 3.5px 3px 4px;
    margin-left: -5px;
    border-radius: 0 4px 4px 0;
    transition: background-color 0.1s ease;
    &:hover {
      background-color: #1576c7 !important;
    }
  }
}
</style>
